import React, { useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Empty } from 'antd';
import Qa from "./qa";
import { useDispatch, useSelector } from "react-redux";

import { filterDomainsForComponent2, getcurrentRoleValue } from "../../utils";
import { generateQaPair } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { Spin, Tag, Tooltip } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import MultiSelectCm from "../../Component/MultiSelectCm/MultiSelectCm";
import SkeletonLoader from "../../Component/SkeletonLoader/SkeletonLoader";
import MultiSelect from "../MultiSelect/MultiSelect";
import Button from "../Button/Button";
import SelectComp from "../Select/Select";
import { alignProperty } from "@mui/material/styles/cssUtils";

const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
  display: 'flex',
  justifyContent: "center",
  alignItems: "center",


};
const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',


};
const containerStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  background: "#FFFFFF",
  boxShadow: "0px 4px 16px 0px #1018280F",
  // padding: "24px 36px 24px 36px",
  minHeight: "100px",
  marginBottom: '24px',
  marginInline: '4px',
  height: "auto"
};


export default function NewGenerateQA() {
  const userState = useSelector((state) => state.user);
  const generateQAState = useSelector((state) => state.generateQA);
  const [generateQA, setGenerateQA] = useState(false)
  console.log("h", generateQAState);
  const dispatch = useDispatch();
  const {
    isLoadingGQA,
    isSearchGQA,
    domainGQA,
    textGQA,
    qaGQA,
    uploadFilesGQA,
  } = bindActionCreators(Actions, dispatch);
  const isDisabled = (text) => {
    var regex = /(<([^>]+)>)/gi;
    var result = text.replace(regex, "");
    return result;
  };
  const convertToPlain = (html) => {
    // Create a new div element
    var tempDivElement = document.createElement("div");

    // Set the HTML content with the given value
    tempDivElement.innerHTML = html;

    // Retrieve the text property of the element
    return tempDivElement.textContent || tempDivElement.innerText || "";
  };
  const onGenerate = () => {
    if (
      !generateQAState.isLoading &&
      (isDisabled(generateQAState.text).length !== 0 ||
        generateQAState.uploadedFiles.length !== 0)
    ) {
      isSearchGQA(true);
      isLoadingGQA(true);
      let payload = {
        text: convertToPlain(generateQAState.text).replace(/<[^>]+>/g, ""),
        files: generateQAState.uploadedFiles[0],
      };
      var fd = new FormData();
      fd.append(
        "text",
        convertToPlain(generateQAState.text).replace(/<[^>]+>/g, "")
      );
      fd.append(
        "files",
        generateQAState.uploadedFiles.length === 0
          ? []
          : generateQAState.uploadedFiles[0]
      );
      generateQaPair(fd).then((res) => {
        if (res === undefined) return;
        if (res.data.success) {
          qaGQA(res.data.data);
          isLoadingGQA(false);
        }
      });
      return;
    }
  };
  const onRemoveQA = (key) => {
    let newArr = generateQAState.qa.filter((obj, index) => {
      if (index !== key) {
        return obj;
      }
    });
    qaGQA(newArr);
  };
  const onEditQA = (key, state) => {
    let newArr = generateQAState.qa.filter((obj, index) => {
      if (index === key) {
        obj.question = state.question;
        obj.answer = state.answer;
      }
      return obj;
    });
    qaGQA(newArr);
  };
  const onChangeDomain = (e) => {
    domainGQA(e);
  };
  const trimImageName = (str) => {
    let imgName = str.length > 30 ? str.slice(0, 30) : str;
    return imgName;
  };
  const isDisabledButton = !generateQAState.isLoading &&
    (isDisabled(generateQAState.text).length !== 0 || generateQAState.uploadedFiles.length !== 0)
    ? false
    : true;

  const primaryButtonStyle = {
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: 400,
    boxShadow: "0px 1px 2px 0px #1018280D",
    color: "#FFFFFF",
    border: "1px solid #fff",
    height: "40px",
    minWidth: "88px",
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    marginBottom: "14px",
    cursor: isDisabledButton ? "not-allowed" : "pointer", // Apply cursor conditionally
    opacity: isDisabledButton ? 0.6 : 1, // Optional: Reduce opacity for disabled state
  };
  return (
    <>
      <div style={{ marginTop: "15px" }}>
        <span style={{ display: "flex", width: "100%", alignItems: "center",paddingTop:"10px",paddingBottom:"10px" }}>
          <span style={textStyles}>Domain (Optional)&nbsp; </span>
          &nbsp;
          <span >
       
            <SelectComp
              width={'200px'}
              isString={false}
              val={generateQAState.domain}
              onChangeFunc={onChangeDomain}
              options={filterDomainsForComponent2(userState.visibleTopics)}
              size={"large"}
              placeholder="Select Domain"
            />
            {/* <SelectComp
              // width={'150px'}
              size={'large'}
              value={generateQAState.domain}
              onChangeFunc={onChangeDomain}
              options={filterDomainsForComponent2(userState.visibleTopics)}
            /> */}
          </span>
        </span>
      </div>
      <div style={{ margin: "auto", width: "100%", display: "flex" }}>
        <div style={{ width: `${!generateQAState.isSearch ? "100%" : "50%"}` }}>
          <div className="mt-2" style={{ width: "100%" }}>
            <ReactQuill
              theme="snow"
              value={generateQAState.text}
              onChange={(e) => textGQA(e)}
            />
            <div
              // className="mt-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                paddingTop: "5px"
              }}
            >
              <span className="mt-1" style={{ fontSize: "14px" }}>
                *Note: Up to 20,000 words allowed
                <br />
                <span>
                  {generateQAState.uploadedFiles.length !== 0 && (
                    <>

                      <Tooltip
                        color="#fff"
                        title={() => {
                          return (
                            <span
                              style={{
                                color: "black",
                                textTransform: "capitalize",
                              }}
                            >
                              {generateQAState.uploadedFiles[0].name}
                            </span>
                          );
                        }}
                      >
                        <Tag
                          style={{ cursor: "pointer" }}
                          closeIcon={<CloseCircleOutlined />}
                          onClose={(e) => {
                            e.preventDefault();
                            uploadFilesGQA([]);
                          }}
                        >
                          {trimImageName(generateQAState.uploadedFiles[0].name)}
                        </Tag>
                      </Tooltip>
                    </>

                  )}
                </span>
              </span>
              <div className="mt-1" style={{ display: "flex", justifyContent: "flex-end" }}>
                <span
                  style={{
                    border: '1px solid #E0E2E6',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    fontSize: '14px',
                    color: '#2A364A',
                    background: '#F6F7F8',
                    fontWeight: '400',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: "pointer", // to keep the pointer cursor
                    marginRight: "7px",
                    padding:"8px 12px",
                    height:'40px',
                    minWidth:"88px"


                  }}
                >
                  <input
                    type="file"
                    accept="image/png,image/gif,image/jpeg,image/jpg,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                    id="generateqafile"
                    onChange={(e) => uploadFilesGQA(e.target.files)}
                    style={{ display: "none", paddingRight: "7px" }}
                  />
                  <label
                    htmlFor="generateqafile" // Changed 'for' to 'htmlFor' for React
                    style={{ cursor: "pointer" }}
                  >
                    Upload File
                  </label>
                </span>


                {/* <Button type={`${!generateQAState.isLoading && (isDisabled(generateQAState.text).length !== 0 || generateQAState.uploadedFiles.length !== 0)
                    ? "primary"
                    : "default"
                  }`} 
                  text={generateQAState.isLoading ? "Generating..." : "Generate"}
                  onClickFunc={onGenerate}
                /> */}
                  <button 
           style={{
		   			    padding: '8px 12px 8px 12px',
						borderRadius: '6px',
						fontSize: '14px',
						lineHeight: '24px',
						fontWeight: 400,
						boxShadow: '0px 1px 2px 0px #1018280D',
						color: '#FFFFFF',
						border: '1px solid  #fff',
						height: '40px',
						minWidth: '88px',
						background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
						marginBottom:'14px'				
						}}
            onClick={()=>onGenerate()}
				
            disabled={isDisabledButton}
						className="saveButton"
						>
           {generateQAState.isLoading ? "Generating..." : "Generate"}
            </button>
                {/* <button
                  style={primaryButtonStyle}
                  disabled={isDisabledButton}
                  className="buttonDark"
                  onClickFunc={onGenerate}
                >
                  {generateQAState.isLoading ? "Generating.ww.." : "Generate"}

                </button>
                <Button type={`${!generateQAState.isLoading && (isDisabled(generateQAState.text).length !== 0 || generateQAState.uploadedFiles.length !== 0)
                    ? "primary"
                    : "default"
                  }`} 
                  text={generateQAState.isLoading ? "Generating..." : "Generate"}
                  onClickFunc={onGenerate}
                /> */}
                {/* <button  disabled={editorState.isButtonEnable}  onClick={()=>sendDraftCall()} className='btn btn-primary videoshowbuttonAB' style={{fontSize:'.9rem' }}><i className='fa fa-save'></i>&nbsp;Save Draft</button>&nbsp; */}



              </div>
            </div>
          </div>
        </div>

        {generateQAState.isSearch && (
          <div
            className="mt-2"
            style={{
              display: `${!generateQAState.isSearch ? "none" : "inline"}`,
              width: "50%",
              height: "650px",
              overflow: "auto",
            }}
          >
            {generateQAState.isLoading && (
              <div style={{ marginLeft: "5px" }}>
                <SkeletonLoader />
              </div>
            )}
            {!generateQAState.isLoading && generateQAState.qa.length === 0 && (
              <div style={{display:'flex',justifyContent:'center',height:"50%",alignItems:"center"}}>
                 <Empty/>
                {/* <span style={{ fontSize: "24px", display: "flex", justifyContent: "flex-end", padding: "15px" }}><CloseCircleOutlined onClick={() => isSearchGQA(false)} /></span> */}
                {/* <span style={textStyles1}>No QA available!</span> */}
              </div>
            )}
            {!generateQAState.isLoading && generateQAState.qa.length !== 0 && (

              <div>
                {generateQAState.qa.map((obj, index) => {
                  return (


                    <Qa
                      onRemove={onRemoveQA}
                      onUpdate={onEditQA}
                      domain={generateQAState.domain}
                      key={obj.question}
                      id={index}
                      q={obj.question}
                      ans={obj.answer}
                    />



                  );
                })}
              </div>

            )}
          </div>
        )}
      </div>
    </>
  );
}
